import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  box-sizing: border-box;
  padding: ${props => props.theme.whiteLabel.spacing.sp24} ${props => props.theme.whiteLabel.spacing.sp8};
`

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
